// extracted by mini-css-extract-plugin
export var alignCenter = "_a5-d";
export var bannerShown = "_a5-6";
export var buttonContent = "_a5-0";
export var cardList = "_a5-1";
export var centerContent = "_a5-2";
export var chevron = "_a5-3";
export var closePanelButton = "_a5-k";
export var conversationContextContainer = "_a5-l";
export var conversationDetailContainer = "_a5-4";
export var detailWrapper = "_a5-7";
export var dropdownButton = "_a5-e";
export var dropdownTitle = "_a5-9";
export var fullHeight = "_a5-5";
export var hidden = "_a5-a";
export var icon = "_a5-b";
export var mergeSuggestionWrapper = "_a5-m";
export var panel = "_a5-i";
export var portalButtonsWrapper = "_a5-c";
export var right = "_a5-j";
export var tableSummaryContainer = "_a5-8";
export var tableSummaryHeader = "_a5-g";
export var threeDotsButton = "_a5-f";
export var wide = "_a5-h";